import * as React from 'react';
import { IMedia, IGenre, IPerson, ICity } from '../../interfaces';
import Favorite from '../parts/Favorite';
import { NavLink } from 'react-router-dom';
import { transliterate } from '../../utils/functions';
import { withTranslation, WithTranslation } from 'react-i18next';

interface IProps extends WithTranslation {
    slide: IMedia,
    isSerial?: boolean,
    t: any
}

class Film extends React.Component<IProps, any>{

    render() {
        let { t } = this.props;
        let { slide } = this.props;

        let date = new Date();
        let dd = String(date.getDate()).padStart(2, '0');
        let mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
        let yyyy = date.getFullYear();

        let today = dd + '.' + mm + '.' + yyyy;

        var d = new Date();
        d.setDate(d.getDate() - 1);

        let dd2 = String(d.getDate()).padStart(2, '0');
        let mm2 = String(d.getMonth() + 1).padStart(2, '0'); //January is 0!
        let yyyy2 = d.getFullYear();

        let yesterday = dd2 + '.' + mm2 + '.' + yyyy2;

        let correctDate = slide.date == today ? t("Сегодня") : (slide.date == yesterday ? t("Вчера") : slide.date);

        let cities = slide.city.length > 0 ? slide.city.map((city: ICity, index: number) => city.name).join(", ") : slide.genre.map((genre: IGenre, index: number) => genre.name).join(", ");
        return (
            <div className="item">
                <div className="img">
                    <NavLink to={`/${this.props.isSerial ? `serial` : `film`}/${transliterate(slide.fullname)}/${slide.media_id}`}> <img src={slide.fullImage} /></NavLink>

                    <div className="play">
                        <NavLink className="scroll-to-top" to={`/${this.props.isSerial ? `serial` : `film`}/${transliterate(slide.fullname)}/${slide.media_id}`}>
                            <i className="fa fa-play-circle-o"></i>
                        </NavLink>
                    </div>

                    <div className="quality">
                        {slide.isNew && <div className="new"> <span> new </span> </div>}
                        <div className={slide.qualityName && slide.qualityName.toLowerCase() == "hd" ? "fullhd" : "hd"}> <span> {slide.qualityName} </span> </div>
                    </div>
                </div>
                <h1 style={{ textAlign: "center" }}> <NavLink to={`/${this.props.isSerial ? `serial` : `film`}/${transliterate(slide.fullname)}/${slide.media_id}`} title={slide.leftName}> {slide.leftName} </NavLink> </h1>
                <p className="mb-0 film-subtitle" style={{ textAlign: "center" }} title={cities}>  {cities} </p>
                <h5 style={{ textAlign: "center" }}> <span> {correctDate} </span> </h5>

                <div className="podrobni">
                    <div className="t">
                        <div className="left">
                            <span className="age"> {slide.age ? slide.age.toString().replace("+", "") + "+" : ""} </span>
                        </div>
                        <div className="center">
                            <span> {slide.genre.map((genre: IGenre) => genre.name).join(", ")} </span>
                        </div>
                        <div className="right">
                            <Favorite media={slide} />
                        </div>
                    </div>
                    <div className="c">
                        {slide.imdb > 0 && <div className="left">
                            <p> <span className="active"> IMDb </span> </p>
                            <p> <span className={"rate " + (slide.imdb < 6 ? "red" : "")}> {slide.imdb} </span> </p>
                        </div>}
                        {slide.critics > 0 && <div className="center">
                            <p> <span className="active"> КиноПоиск </span> </p>
                            <p> <span className={"rate " + (slide.critics < 6 ? "red" : "")}> {slide.critics} </span> </p>
                        </div>}
                        <div className="right">
                            <p> <span> {t("Просмотров")} </span> </p>
                            <p> <span className="count"> {slide.reviews} </span> </p>
                        </div>
                    </div>
                    {slide.director.length > 0 && (<p className="r">
                        <span className="active"> {t("Режиссер")} </span>
                        {
                            slide.director.map((director: IPerson, index: number) => director.first + " " + director.last + (index + 1 != slide.director.length ? ", " : ""))
                                .map((full: string, index: number) => <span key={index}>{full}</span>)
                        }
                    </p>)}
                    {slide.actor.length > 0 && (<p className="rol">
                        <span className="active"> {t("В ролях")} </span>
                        {
                            slide.actor.map((actor: IPerson, index: number) => actor.first + " " + actor.last + (index + 1 != slide.actor.length ? ", " : ""))
                                .map((full: string, index: number) => <span key={index}>{full}</span>)
                        }
                    </p>)}

                    <p className="description" dangerouslySetInnerHTML={{
                        __html: slide.info ? slide.info.replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, " ").split(".").shift() + "." : ""
                    }}>
                    </p>
                </div>

            </div>
        );
    }
}

export default withTranslation()(Film);